<template lang="pug">
#page_index.page
	#landing.carousel.slide(data-bs-ride='carousel')
		.carousel-indicators
			button.active(
				type='button',
				data-bs-target='#landing',
				data-bs-slide-to='0',
				aria-current='true',
				aria-label='Slide 1'
			)
			button(
				type='button',
				data-bs-target='#landing',
				data-bs-slide-to='1',
				aria-label='Slide 2'
			)
			button(
				type='button',
				data-bs-target='#landing',
				data-bs-slide-to='2',
				aria-label='Slide 3'
			)
		.carousel-inner
			.carousel-item(
				v-for='(item, index) in items_banner',
				v-bind:style='{ backgroundImage: "url(" + item + ")" }',
				v-bind:class='{ active: index === 0 }'
			)
	.particle_wrapper
		#particle

	.container.to_front
		.row
			.col-12.button_competition
				a(href='/Rule')
					.text 徵件辦法
				a(href='https://filmfreeway.com/TICFF', target='_blank')
					.text FilmFreeway

	.container.to_front
		TitleStar
			template(v-slot:title) {{ $t('nav_about_news_list') }}
			//- Use vue slot to handle content
			//- https://v3.vuejs.org/guide/component-slots.html#slot-content
		.row
			.col-md-4(v-for='item in items_news')
				CardVertical(v-bind:item='item', classes='index')

	.container
		.title_underline
			h2.text {{ $t('index_recommend') }}
			img(src='@/assets/images/title_underline.png')
		.row
			.col-md-4(v-for='item in items_recommend')
				CardFull(v-bind:item='item', classes='external_link')

		router-link(v-bind:to='{ name: "VideoList" }')
			.button_action
				.wrapper
					.text {{ $t('index_recommend_more') }}
					img(src='@/assets/images/icon_play.png')

	.container.index_sponsor
		//- TitleStar
			template(v-slot:title) {{ $t('index_sponsorship') }}
			//- Use vue slot to handle content
			//- https://v3.vuejs.org/guide/component-slots.html#slot-content
		.d-flex.flex-wrap
			a.sponsor_item(
				:href='item.link',
				v-for='item in sponsor_items',
				target='_blank'
			)
				img(:src='item.image')
</template>

<script>
import { indexNews, indexBanner } from '@/router/api.js';
import { tsParticles } from 'tsparticles';
import ParticleConfig from '@/assets/particles.json';
import CardFull from '@/components/CardFull.vue';
import CardVertical from '@/components/CardVertical.vue';
import TitleStar from '@/components/TitleStar.vue';

export default {
	data() {
		return {
			particle_top: null,
			items_news: [],
			items_banner: [],
			items_recommend: {},
			sponsor_items: [
				{
					image: require('@/assets/images/sponsor/sponsor_18.png'),
					link: 'https://www.mdnkids.com/',
				},
				{
					image: require('@/assets/images/sponsor/sponsor_19.png'),
					link: 'https://www.top945.com.tw/Promo/20220210/index.asp?cf=042045',
				},
				{
					image: require('@/assets/images/sponsor/sponsor_20.png'),
					link: 'https://bit.ly/3JDLckO',
				},
				{
					image: require('@/assets/images/sponsor/sponsor_21.png'),
					link: 'https://www.juschool.com.tw/kids/?actid=2022GSYZ',
				},
				{
					image: require('@/assets/images/sponsor/sponsor_22.png'),
					link: 'https://artouch.com/kids',
				},
			],
		};
	},
	methods: {
		getNews: function () {
			indexNews().then(res => {
				this.items_news = res.data.slice(0, 6).map(item => {
					return {
						...item,
						image: process.env.VUE_APP_WP_IMAGE_PREFIX + item.image,
					};
				});
			});
		},
		getBanner: function () {
			indexBanner().then(res => {
				this.items_banner = res.data.map(
					item => process.env.VUE_APP_WP_IMAGE_PREFIX + item
				);

				// todo: if backend wordpress folder is ready, below is what actually need to do

				// if (process.env.NODE_ENV === 'development') {
				// 	this.items_banner = res.data.map(item => process.env.VUE_APP_WP_IMAGE_PREFIX + item);
				// } else {
				// 	this.items_banner = res.data;
				// }
			});
		},
		setRecommend: function () {
			let temp = require(`@/assets/data/recommend_${this.$i18n.locale}.yaml`);
			this.items_recommend = temp.map(item => {
				let title =
					this.$i18n.locale === 'tw' ? item.title_tw : item.title_en;
				return {
					...item,
					title: title,
					image:
						item.image !== ''
							? require(`@/assets/images/film_photo/program/${item.id}/${item.image}`)
							: '',
					desc: `${item.type[0]} | ${item.film_length} ${this.$t(
						'general_minute'
					)} | ${item.rated}`,
				};
			});
		},
		// setSponsor: function () {
		// 	this.sponsor_items = temp.map(item => {
		// 		return {
		// 			link: `${item.sponsor.link}`,
		// 			image: `${item.sponsor.image}`,
		// 		};
		// 	});
		// },
	},
	mounted() {
		this.getNews();
		this.getBanner();
		this.setRecommend();
		// this.setSponsor();
		setTimeout(() => {
			tsParticles.load('particle', ParticleConfig);
			this.particle_top = tsParticles.domItem(0);
		}, 1000);
		// setTimeout(() => {
		// 	this.particle_top.destroy();
		// }, 4000);
	},
	watch: {
		'$i18n.locale'() {
			this.getNews();
			this.setRecommend();
		},
	},

	components: {
		CardFull,
		CardVertical,
		TitleStar,
	},
};
</script>

<style lang="stylus">
#page_index
	#landing
		min-height: 200px
		.carousel-item
			width: 100%
			height: 100vh
			background-size: cover
			background-position: center center
			mask: url('~@/assets/images/index_banner.png') no-repeat center center
			mask-size: 100vw 100%
			@media screen and (max-width: $screen-sm-max)
				height: 30vh

	.particle_wrapper
		position: absolute
		width: 100%
		height: 500px
		#particle
			position: absolute
			width: 100%
			height: 100%
	.container, .container-fluid
		padding-top: 3rem
		&.to_front
			position: relative
	.button_competition
		display: flex
		flex-direction: row
		justify-content: space-around
		.text
			padding: 14px 5rem
			background-color: $color_yellow
			border-radius: 10px
			box-shadow: 5px 4px 30px rgba(0, 0, 0, 0.3)
			color: $color_dark
			font-size: 18px
			font-weight: 500
			cursor: pointer
			@media screen and (max-width: $screen-sm-max)
				padding: 8px 2rem

	.button_action
		margin-top: 44px
		cursor: pointer
	.sponsor_item
		width: calc(20% - 20px)
		max-width: 200px
		margin 0 10px 20px
		img
			display: block
			border-radius: 4px;
			width: 100%
		@media screen and (max-width: $screen-lg)
			width: calc(33.33333% - 20px)
		@media screen and (max-width: $screen-sm-max)
			width: calc(50% - 20px)
	.index_sponsor
		margin-top: 150px
		@media screen and (max-width: $screen-sm-max)
			margin-top: 100px

	@media screen and (max-width: $screen-sm-max)
		#landing
			.carousel-item
				margin-top: 60px
				height: 25vh
</style>
